import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/** Sends a visitor with no session to the identity provider, and keeps trying
 *  until they are back: the round trip may need a second attempt while the
 *  provider is still writing its cookie.
 */
export function KeycloakHandover({ loginUrl }: { loginUrl: string | null }) {
    const { t } = useTranslation();
    const [waiting, setWaiting] = useState(false);

    useEffect(() => {
        if (!loginUrl || waiting) {
            return;
        }
        const timer = window.setTimeout(() => {
            setWaiting(true);
            window.location.assign(loginUrl);
        }, 120);
        return () => window.clearTimeout(timer);
    }, [loginUrl, waiting]);

    return (
        <div className="pm-boot">
            <p>{t("auth.sendingToIdentityProvider")}</p>
            {loginUrl && (
                <p>
                    <a className="pm-button" href={loginUrl}>
                        {t("auth.continueToSignIn")}
                    </a>
                </p>
            )}
        </div>
    );
}
